module.exports = __webpack_public_path__ + "img/upload-arrow-dark.f18125d7.svg";